module.exports = __webpack_public_path__ + "img/Accesorios.20003fdd.png";